export default __webpack_public_path__ + "locales/az/ResetApplicationDialog.json?hash=644aeccb1786eb70dcf3f95c06841749";